import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useRef, useState} from "react";
import {fetchAdvancedTypes, fetchBankAccounts} from "../../../../_apis/api";
import {
    delay, getCurrentUser,
    getGreekCurrencyFormat, hookCompanyLogo,
    isEmpty, quickClone
} from "../../../../_helpers/commonFunctions";
import {
    setBankingAITransactionReportUniqueSelection,
    setBankingAITransactionsReportRequestData,
    setBankingAITransactionsReportResponseData,
    setBankingAITransactionsSelected, setHookTransactionModalData,
    setMyConnectedBanks, setShowHookTransactionModal,
} from "../../../../_reducers/DataPanel/Accounting/accountingSlice";
import moment from "moment/moment";
import axios from "axios";
import {toast} from "react-toastify";
import {Badge, ButtonGroup, Col, Modal, Row, Spinner} from "react-bootstrap";
import OurDropdown from "../../../primer/Dropdown";
import Button from "react-bootstrap/esm/Button";
import {FaArrowDown, FaArrowUp, FaDownload, FaRobot, FaHistory} from "react-icons/fa";
import {RiBankFill} from "react-icons/ri";
import {BsEnvelopeFill, BsInfoCircleFill} from "react-icons/bs";
import DateHelper from "../../../primer/DateHelper/DateHelper";
import DateBox from "../../../primer/DateBox";
import Input from "../../../common/Input";
import {TbLayersDifference, TbReload} from "react-icons/tb";
import Pagination from "../../../primer/Pagination";
import BootstrapDropdown from "react-bootstrap/esm/Dropdown";
import BankTransactionsModal from "./BankTransactionsModal";
import HookTransactionModal from "./HookTransactionModal";
import UploadMT940Modal from "./UploadMT940Modal";
import BetterCheckBox from "../../../common/BetterCheckBox";
import {IoReload, IoSend} from "react-icons/io5";
import {MdOutlineCancel} from "react-icons/md";
import {jsPDF} from "jspdf";
import {liberationSerif} from "../../../../fonts/liberationSerif";
import {dejavuSans} from "../../../../fonts/DejaVuSans-normal";
import {dejavuSansBold} from "../../../../fonts/DejaVuSans-Bold-bold";
import {autoTable} from "jspdf-autotable";
import * as XLSX from "xlsx";
import LoadingDots from "../../../common/LoadingDots";
import "./banking-styles.css";
import DeleteDecorrelateModal from "./components/DeleteDecorrelateModal";

const AccountingAIBankingTransactions = () => {
    const dispatch = useDispatch();
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const companyDetails = useSelector((state) => state.COMPANY_DATA.companyDetails);
    const myConnectedBanks = useSelector((state) => state.ACCOUNTING_DATA.myConnectedBanks);
    const requestData = useSelector((state) => state.ACCOUNTING_DATA.bankingAITransactionsRequestData);
    const responseData = useSelector((state) => state.ACCOUNTING_DATA.bankingAITransactionsResponseData);
    const selectedTransactions = useSelector((state) => state.ACCOUNTING_DATA.bankingAITransactionsSelectedTransactions);
    const bankingTransactionReportUniqueSelection = useSelector((state) => state.ACCOUNTING_DATA.bankingAITransactionReportUniqueSelection);
    const bankingCategories = useSelector((state) => state.ACCOUNTING_DATA.bankingCategories);
    const bankingSubCategories = useSelector((state) => state.ACCOUNTING_DATA.bankingSubCategories);

    const [pageChanged, setPageChanged] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingExport, setLoadingExport] = useState(false);

    const [massLoading, setMassLoading] = useState(false);
    const [showMassModal, setShowMassModal] = useState(false);
    const [massAction, setMassAction] = useState("");

    const [showFetchTransactions, setShowFetchTransactions] = useState(false);
    const [loadingEmailSync, setLoadingEmailSync] = useState(false);
    const [showDeccorelateSelections, setShowDeccorelateSelections] = useState(false);
    const [showDeccorelateAndDeleteSelections, setShowDeccorelateAndDeleteSelections] = useState(false);
    const [showMT940Modal, setShowMT940Modal] = useState(false);

    const [loadingDecorrelate, setLoadingDecorrelate] = useState(false);

    const [scrollToDiff, setScrollToDiff] = useState(false);
    const diffRef = useRef(null);

    const isAdmin = getCurrentUser()?.userType === "Admin";

    const [showReprocessAll, setShowReprocessAll] = useState(false);
    const [loadingReprocessAll, setLoadingReprocessAll] = useState(false);

    const [showLogsModal, setShowLogsModal] = useState(false);
    const [logsData, setLogsData] = useState([]);
    const [loadingLogs, setLoadingLogs] = useState(false);
    const [logsPage, setLogsPage] = useState(1);
    const [logsTotalPages, setLogsTotalPages] = useState(1);
    const [showInfo, setShowInfo] = useState(false);
    const [doNotReshow3, setDoNotReshow3] = useState(false);

    const hasPendingTransactions = responseData.data.some((transaction) => [200, 201].includes(transaction.ai_status));

    const statusOptions = [
        {label: "Πλήρως συσχετισμένη", value: "complete"},
        {label: "Μερικώς συσχετισμένη", value: "pending"},
        {label: "Ασυσχέτιστη", value: "empty"},
    ]

    const signOptions = [
        {label: "Προβολή όλων", value: ""},
        {label: "Προβολή χρεώσεων (-)", value: "-"},
        {label: "Προβολή πιστώσεων (+)", value: "+"},
    ]

    const accountOptions = myConnectedBanks.map((o) => {
        return {
            label: o.identifier,
            value: o.accountId,
            iban: o.iban,
            hooked: o.hooked,
        }
    }).filter(Boolean);

    const subCategoryOptions = bankingSubCategories.map((o) => {
        return {
            label: o.title,
            value: o._id,
        }
    })

    useEffect(() => {
        fetchMyAccounts();
        dispatch(fetchAdvancedTypes({ company: company.id }));
        dispatch(fetchBankAccounts({ company: company.id }));
        if (isEmpty(requestData.date_from) && isEmpty(requestData.date_to)) {
            dispatch(setBankingAITransactionsReportRequestData({
                ...requestData,
                date_from: moment(company.year, "YYYY").startOf("year").format("DD/MM/YYYY"),
                date_to: moment(company.year, "YYYY").endOf("year").format("DD/MM/YYYY"),
            }))
        }
    }, [])

    useEffect(() => {
        if (pageChanged) {
            setPageChanged(false);
            fetchReport(true);
        }
    }, [pageChanged]);

    const handleOpenInfo = () => setShowInfo(true);
    const handleCloseInfo = () => setShowInfo(false);

    const aiStatusOptions = [
        {value: "not_sent", label: "Μη απεσταλμένη"},
        {value: "error", label: "Σφάλμα"},
        {value: "waiting", label: "Αναμονή επεξεργασίας από Primer AI"},
        {value: "user_action", label: "Αναμονή ενεργειών χρήστη"},
        {value: "user_decline", label: "Απόρριψη από χρήστη"},
        {value: "registered", label: "Καταχωρημένη"},
    ]

    const formatAIBankingStatus = (transaction) => {
        const ai_status = transaction?.ai_status;

        if (!ai_status) return "-";
        else if (ai_status === -1) return "Αδυναμία επεξεργασίας";
        else if (ai_status === -121) return `Μη επεξεργάσιμη συναλλαγή: ${transaction.ai_nonReadableReason}`;
        else if (ai_status === -123) return `Μη επεξεργάσιμη συναλλαγή, η επανεπεξεργασία θα ξανατρέξει αυτόματα: ${transaction.ai_nonReadableReason}`;
        else if ([200, 201].includes(ai_status)) return <>Αναμονή επεξεργασίας από Primer AI<LoadingDots/></>;
        else if (ai_status === -200) return <>Αναμονή επεξεργασίας από Primer AI<LoadingDots/></>;
        else if (ai_status === 500) return "Ολοκλήρωση επεξεργασίας, αναμονή ενεργειών χρήστη";
        else if (ai_status === -501) return "Απόρριψη από χρήστη";
        else if (ai_status === 1000) return "Καταχωρημένο από Primer AI";
        else if (ai_status === 1001) return "Καταχωρημένο με την βοήθεια του Primer AI";
    }

    const formatAIBankingStatusColor = (transaction) => {
        const ai_status = transaction?.ai_status;

        if (!ai_status) return "";
        if (ai_status === -501) return "ai-status-user-action";
        if ([-121, -123, -1].includes(ai_status)) return "ai-status-error";
        if ([1000, 1001].includes(ai_status)) return "ai-status-success";
        return "ai-status-process";
    }

    const fetchMyAccounts = () => {
        axios.get(`${process.env.REACT_APP_API_URL2}/accounting/banking-my-accounts`, {
            headers: { 'Content-Type': 'application/json' },
            params: {
                company: company.id,
                includeAll: "true",
            }
        }).then((res) => {
            if (res.data.status === "200") {
                const accs = res.data.data;
                if (accs?.length > 0) {
                    if (accs.length === 1 && isEmpty(requestData.accountId)) {
                        setTimeout(() => {
                            dispatch(setBankingAITransactionsReportRequestData({
                                ...requestData,
                                accountId: accs[0].accountId,
                                date_from: moment(company.year, "YYYY").startOf("year").format("DD/MM/YYYY"),
                                date_to: moment(company.year, "YYYY").endOf("year").format("DD/MM/YYYY"),
                            }));
                        }, 100)
                    }
                    dispatch(setMyConnectedBanks(accs));
                }
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    const fetchReport = (fromPagination = false) => {
        setLoading(true);
        const reqData = {...requestData};
        if (!fromPagination) {
            reqData.page = 1;
            dispatch(setBankingAITransactionsReportRequestData(reqData));
        }
        axios.get(`${process.env.REACT_APP_API_URL2}/accounting/banking-transactions`, {
            headers: { 'Content-Type': 'application/json' },
            params: {
                ...reqData,
                company: company.id,
                upgraded: true,
            }
        }).then((res) => {
            if (res.data.status === "200") {
                if (!fromPagination) {
                    if (res.data.data.totalPages > 0) {
                        toast.success("Τα δεδομένα ανανεώθηκαν.", {autoClose: 1000});
                    } else {
                        toast.info("Δεν βρέθηκαν συναλλαγές.", {autoClose: 1000});
                    }
                }
                dispatch(setBankingAITransactionsReportResponseData({
                    ...responseData,
                    data: res.data.data.data,
                    totalPages: res.data.data.totalPages,
                    totals: res.data.totals,
                    transactionIds: res.data.transactionIds,
                    differencePage: res.data.differencePage,
                    differenceId: res.data.differenceId,
                }));
                if (res.data.differenceId && scrollToDiff) {
                    setScrollToDiff(false);
                    dispatch(setBankingAITransactionReportUniqueSelection(res.data.differenceId));
                    setTimeout(() => {
                        if (diffRef) diffRef.current?.scrollIntoView({behavior: "smooth", container: "nearest"});
                    }, 200)
                }
            } else {
                toast.error(res.data.message);
            }
            setLoading(false);
        }).catch((err) => {
            setLoading(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const fetchReportRef = useRef(fetchReport);

    useEffect(() => {
        fetchReportRef.current = fetchReport;
    });

    useEffect(() => {
        if (!hasPendingTransactions) return;
        const intervalId = setInterval(() => {
            fetchReportRef.current(true);
        }, 7500);
        return () => clearInterval(intervalId);
    }, [hasPendingTransactions]);

    const fetchEmailLogs = (page = 1) => {
        setLoadingLogs(true);
        axios.get(`${process.env.REACT_APP_API_URL2}/company/email-banking-logs`, {
            params: {
                company: company.id,
                page: page
            }
        }).then((res) => {
            if (res.data && (res.data.status === "200" || res.data.status === "success")) {
                setLogsData(res.data.data || []);
                setLogsTotalPages(res.data.totalPages || 1);
                setLogsPage(page);
            } else {
                toast.error(res.data.message || "Σφάλμα κατά την άντληση του ιστορικού.");
            }
        }).catch((err) => {
            console.error(err);
            toast.error("Σφάλμα κατά την επικοινωνία με τον server.");
        }).finally(() => {
            setLoadingLogs(false);
        });
    }

    const handleEmailSync = () => {
        setLoadingEmailSync(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/accounting/collect-emails`, {user: getCurrentUser()._id})
            .then((res) => {
                if (res.data && (res.data.status === "success" || res.data.status === "200")) {
                    const processedCount = res.data.data ? res.data.data.length : 0;

                    if (processedCount > 0) {
                        toast.success(`Ο συγχρονισμός ολοκληρώθηκε! Επεξεργάστηκαν ${processedCount} αρχεία.`);
                        fetchReport(true);
                    } else {
                        toast.info(res.data.message);
                    }
                } else {
                    toast.error(res.data.message);
                }
            })
            .catch((err) => {
                console.error(err);
                toast.error("Σφάλμα κατά την επικοινωνία με τον server.");
            })
            .finally(() => {
                setLoadingEmailSync(false);
            });
    }

    const handlePageChange = (page, scrollToDiff = false) => {
        dispatch(setBankingAITransactionsReportRequestData({...requestData, page: page}));
        setPageChanged(true);
        if (scrollToDiff) setScrollToDiff(true);
    }

    const handleOnChange = (e, type, name) => {
        const prepChanges = {};
        if (type === "dd") {
            prepChanges[name] = e.value;
        } else if (type === "msdd") {
            prepChanges[name] = e.flatMap((o) => o.value);
        } else if (type === "datebox") {
            if (moment(e).isValid()) {
                prepChanges[name] = moment(e).format("DD/MM/YYYY");
            } else {
                prepChanges[name] = "";
            }
        } else if (type === "input") {
            prepChanges[name] = e.target.value;
        }
        dispatch(setBankingAITransactionsReportRequestData({...requestData, ...prepChanges}));
    }

    const handleDocumentAction = (transaction, section) => {
        dispatch(setShowHookTransactionModal(true));
        if (transaction.ai_drafts && transaction.ai_drafts[0]) {
            dispatch(setHookTransactionModalData({
                transaction: transaction,
                section: transaction.ai_drafts[0].documentSection,
                documentHooks: transaction?.documentHooks || [],
            }));
        } else {
            dispatch(setHookTransactionModalData({
                transaction: transaction,
                section: section,
                documentHooks: transaction?.documentHooks || [],
            }));
        }
    }

    const getDocumentHooksStatus = (status) => {
        if (status === "complete") {
            return (
                <div style={{lineHeight: "20px"}}>
                    <span style={{ color: "green", marginRight: "4px" }}>◉</span>
                    <span>Πλήρως συσχετισμένη</span>
                </div>
            )
        } else if (status === "pending") {
            return (
                <div style={{lineHeight: "20px"}}>
                    <span style={{ color: "#ccc610", marginRight: "4px" }}>◉</span>
                    <span>Μερικώς συσχετισμένη</span>
                </div>
            )
        } else if (status === "empty" || isEmpty(status)) {
            return (
                <div style={{lineHeight: "20px"}}>
                    <span style={{ color: "red", marginRight: "4px" }}>◉</span>
                    <span>Ασυσχέτιστη</span>
                </div>
            )
        }
        return status;
    }

    const toggleSelectAll = () => {
        if (responseData?.transactionIds?.length === selectedTransactions.length) {
            dispatch(setBankingAITransactionsSelected([]));
        } else {
            dispatch(setBankingAITransactionsSelected(responseData.transactionIds));
        }
    }

    const toggleSelection = (id) => {
        if (selectedTransactions.includes(id)) {
            dispatch(setBankingAITransactionsSelected(selectedTransactions.filter((el) => el !== id)));
        } else {
            dispatch(setBankingAITransactionsSelected([...selectedTransactions, id]));
        }
    }

    const clearSelections = () => {
        dispatch(setBankingAITransactionsSelected([]));
    }

    const handleDeccorelateSelections = () => {
        setLoadingDecorrelate(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/accounting/banking-decorrelate-selections`, {
            company: company.id,
            transactionIds: selectedTransactions,
        }).then((res) => {
            if (res.data.status === "200") {
                setShowDeccorelateSelections(false);
                toast.success("Επιτυχής ενέργεια.");
                fetchReport(true);
            } else {
                toast.error(res.data.message);
            }
            setLoadingDecorrelate(false);
        }).catch((err) => {
            setLoadingDecorrelate(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const handleAI = (transaction, action, forceDrafts = null) => {
        axios.post(`${process.env.REACT_APP_API_URL2}/accounting/banking-ai-transaction`, {
            company: company.id,
            transactionId: transaction._id,
            action,
            forceDrafts: forceDrafts,
        }).then((res) => {
            if (res.data.status === "200") {
                toast.success("Επιτυχής ενέργεια.", {autoClose: 1000});
                fetchReport(true);
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const renderActionButtons = (transaction) => {
        const ai_status = transaction?.ai_status;

        let sendButton = false;
        let registerButton = false;
        let reprocessButton = false;
        let declineButton = false;

        const canSendOrReprocess = !transaction.documentHooks || transaction.documentHooks?.length === 0;

        if (!ai_status && canSendOrReprocess) sendButton = true;
        if ([-1, -121, 500, -501].includes(ai_status) && canSendOrReprocess) reprocessButton = true;
        if ([500].includes(ai_status)) declineButton = true;
        if ([500].includes(ai_status)) registerButton = true;

        let compArr = [];
        if (sendButton) {
            compArr.push(
                <div key={`${transaction._id}-onSend`} className={"ai-module-button ai-module-reprocess-style"} onClick={(e) => {
                    e.stopPropagation();
                    handleAI(transaction, "send")
                }} title={"Αποστολή σε Primer AI"}>
                    <IoSend size={22} />
                </div>
            )
        }
        if (registerButton) {
            compArr.push(
                <div key={`${transaction._id}-onFastRegister`} className={"ai-module-button ai-module-save-style"} onClick={(e) => {
                    e.stopPropagation();
                    handleAI(transaction, "register")
                }} title={"Γρήγορη Καταχώρηση"}>
                    <FaRobot size={22} />
                </div>
            )
        }
        if (reprocessButton) {
            compArr.push(
                <div key={`${transaction._id}-onReprocess`} className={"ai-module-button ai-module-reprocess-style"} onClick={(e) => {
                    e.stopPropagation();
                    handleAI(transaction, "reprocess")
                }} title={"Επανεπεξεργασία από Primer AI"}>
                    <IoReload size={22} />
                </div>
            )
        }
        if (declineButton) {
            compArr.push(
                <div key={`${transaction._id}-onDecline`} className={"ai-module-button ai-module-decline-style"} onClick={(e) => {
                    e.stopPropagation();
                    handleAI(transaction, "decline")
                }} title={"Απόρριψη αποτελέσματος Primer AI"}>
                    <MdOutlineCancel size={22} />
                </div>
            )
        }
        return compArr;
    }

    const handlePDFExport = async () => {
        setLoadingExport(true);
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL2}/accounting/banking-transactions`, {
                headers: { 'Content-Type': 'application/json' },
                params: {
                    ...requestData,
                    page: -1,
                    company: company.id,
                }
            })
            if (response.data.status === "200") {
                const resData = quickClone(response.data.data.data).reverse();
                let rows = [];
                const headerColumns = ["Περιγραφή Συναλλαγής", "Ημερομηνία", "Ποσό πράξης", "Υπόλοιπο Όψεως", "Υπόλοιπο Λογιστικού Λογαριασμού"];
                for (const transaction of resData) {
                    rows.push([
                        String(transaction["erp_description"]).replaceAll("\n", " "),
                        moment(transaction["valueDate"]).format("DD/MM/YYYY"),
                        getGreekCurrencyFormat(transaction.transactionAmount),
                        getGreekCurrencyFormat(transaction["runningBalance"] || 0),
                        transaction["accountingBalance"] === "-" ? ">>" : getGreekCurrencyFormat(transaction["accountingBalance"] || 0),
                    ])
                }
                rows.push([
                    {content: "Σύνολο Χρεώσεων", colSpan: 4, styles: {halign: "right"}},
                    getGreekCurrencyFormat(responseData.totals.totalDebit),
                ])
                rows.push([
                    {content: "Σύνολο Πιστώσεων", colSpan: 4, styles: {halign: "right"}},
                    getGreekCurrencyFormat(responseData.totals.totalCredit),
                ])
                rows.push([
                    {content: "Λογιστικό Αποτέλεσμα", colSpan: 4, styles: {halign: "right"}},
                    getGreekCurrencyFormat(responseData.totals.totalSum),
                ])

                const doc = new jsPDF('landscape');
                let y = 23;

                doc.addFileToVFS("arialuni.ttf", liberationSerif);
                doc.addFont("arialuni.ttf", "Arial Unicode MS", "normal");
                doc.addFileToVFS("dejavusans.ttf", dejavuSans);
                doc.addFont("dejavusans.ttf", "DejaVu Sans Normal", "normal");
                doc.addFileToVFS("dejavusansBold.ttf", dejavuSansBold);
                doc.addFont("dejavusansBold.ttf", "DejaVu Sans Bold", "normal");

                hookCompanyLogo(doc, companyDetails);

                const imgData = 'assets/images/prrimer-logo.png';
                const primerWidth = 28;
                const primerHeight = 10;
                const pageWidth = doc.internal.pageSize.getWidth();
                const pageHeight = doc.internal.pageSize.getHeight();
                doc.addImage(imgData, 'PNG', pageWidth - primerWidth - 10, pageHeight - primerHeight - 5, primerWidth, primerHeight);
                doc.setFont("DejaVu Sans Bold");
                doc.setFontSize(10);
                const header = doc.splitTextToSize(`Τραπεζικές συναλλαγές περιόδου ${requestData.date_from} - ${requestData.date_to}`, 200);
                const headerString = header.join("\n");
                doc.text(headerString, doc.internal.pageSize.getWidth() / 4, 9, {alignment: "center"});

                doc.setFont("DejaVu Sans Normal");
                doc.setFontSize(9);
                doc.text(`Τραπεζικός Λογαριασμός: ${selectedBank.label}`, 15, 14, {alignment: "center"});
                doc.text(`${company.name}, ΑΦΜ: ${company.vatNumber}`, 15, 18, {alignment: "center"});
                doc.text(`ΔΟΥ: ${companyDetails.doy}`, 15, 22, {alignment: "center"});
                doc.text(`Ημερομηνία Εξαγωγής: ${moment().format("DD/MM/YYYY")}`, 190, 21, {alignment: "center"});

                autoTable(doc, {
                    startY: y,
                    head: [headerColumns],
                    body: rows,
                    rowPageBreak: "avoid",
                    styles: {
                        font: "DejaVu Sans Normal",
                        fontStyle: "normal",
                        fontSize: 8,
                        halign: "center",
                    },
                })

                const pageCount = doc.getNumberOfPages();
                for (let i = 1; i <= pageCount; i++) {
                    doc.setPage(i);
                    doc.setFontSize(10);
                    doc.text(`Σελίδα ${i} από ${pageCount}`, 10, doc.internal.pageSize.getHeight() - 10);
                }

                doc.save(`Τραπεζικές συναλλαγές.pdf`);
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            console.log(error);
            toast.error("Σφάλμα κατά την άντληση δεδομένων.");
        }
        setLoadingExport(false);
    }

    const handleExcelExport = async () => {
        setLoadingExport(true);
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL2}/accounting/banking-transactions`, {
                headers: {'Content-Type': 'application/json'},
                params: {
                    ...requestData,
                    page: -1,
                    company: company.id,
                }
            })
            if (response.data.status === "200") {
                const resData = quickClone(response.data.data.data).reverse();
                const rows = [];
                rows.push(["Επωνυμία:", company.name]);
                rows.push(["ΑΦΜ:", company.vatNumber]);
                rows.push(["ΔΟΥ:", companyDetails.doy]);
                rows.push([`Εύρος ημερομηνίας:`, `${requestData.date_from} - ${requestData.date_to}`]);
                rows.push([`Ημερομηνία Εξαγωγής:`, `${moment().format("DD/MM/YYYY HH:mm:ss")}`]);
                rows.push([`Τραπεζικός Λογαριασμός:`, selectedBank.label]);
                rows.push([]);

                const headerColumns = ["Περιγραφή Συναλλαγής", "Ημερομηνία", "Ποσό πράξης", "Υπόλοιπο Όψεως", "Υπόλοιπο Λογιστικού Λογαριασμού"];
                rows.push(headerColumns);
                for (const transaction of resData) {
                    rows.push([
                        String(transaction["erp_description"]).replaceAll("\n", " "),
                        moment(transaction["valueDate"]).format("DD/MM/YYYY"),
                        getGreekCurrencyFormat(transaction.transactionAmount),
                        getGreekCurrencyFormat(transaction["runningBalance"] || 0),
                        transaction["accountingBalance"] === "-" ? ">>" : getGreekCurrencyFormat(transaction["accountingBalance"] || 0),
                    ])
                }
                const workSheet = XLSX.utils.aoa_to_sheet(rows);
                const workBook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workBook, workSheet, "Τραπεζικές Συναλλαγές");
                XLSX.writeFile(workBook, 'Τραπεζικές Συναλλαγές.xlsx');
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            console.log(error);
            toast.error("Σφάλμα κατά την άντληση δεδομένων.");
        }
        setLoadingExport(false);
    }

    const renderMassActions = () => {
        return (
            <div>
                <div className={"text-muted"}><i>Ενέργειες ΑΙ</i></div>
                <div
                    className={"ai-module-button ai-module-save-style mt-1 pr-2"}
                    title={"Καταχώρηση επιλεγμένων"}
                    onClick={() => openMassModal("register")}
                >
                    <FaRobot size={18} className={"mr-1"} />
                    Καταχώρηση επιλεγμένων
                </div>
                <div
                    className={"ai-module-button ai-module-reprocess-style mt-1 pr-2"}
                    title={"Αποστολή επιλεγμένων"}
                    onClick={() => openMassModal("send")}
                >
                    <IoSend size={18} className={"mr-1"} />
                    Αποστολή επιλεγμένων
                </div>
                <div
                    className={"ai-module-button ai-module-reprocess-style mt-1 pr-2"}
                    title={"Επαναεπεξεργασία επιλεγμένων"}
                    onClick={() => openMassModal("reprocess")}
                >
                    <TbReload size={18} className={"mr-1"} />
                    Επαναεπεξεργασία επιλεγμένων
                </div>
                <div
                    className={"ai-module-button ai-module-decline-style mt-1 pr-2"}
                    title={"Απόρριψη επιλεγμένων"}
                    onClick={() => openMassModal("decline")}
                >
                    <MdOutlineCancel size={18} className={"mr-1"} />
                    Απόρριψη επιλεγμένων
                </div>
            </div>
        )
    }

    const openMassModal = (action) => {
        setShowMassModal(true);
        setMassAction(action);
    }

    const onMassAction = async () => {
        let totalSuccess = 0;
        setMassLoading(true);
        for (const transactionId of selectedTransactions) {
            try {
                await delay(50);
                await axios.post(`${process.env.REACT_APP_API_URL2}/accounting/banking-ai-transaction`, {
                    company: company.id,
                    transactionId,
                    action: massAction,
                }).then((res) => {
                    if (res.data.status === "200") {
                        totalSuccess++;
                    }
                }).catch((err) => {
                    console.log(err);
                    toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
                })
            } catch (_) {}
        }
        setMassLoading(false);
        setShowMassModal(false);
        fetchReport(true);
        toast.success(`Επιτυχής ενέργεια σε ${totalSuccess} συναλλαγές.`);
    }

    const renderMassActionTitle = () => {
        if (massAction === "send") return "Μαζική αποστολή σε Primer ΑΙ";
        if (massAction === "decline") return "Μαζική απόρριψη";
        if (massAction === "register") return "Μαζική καταχώρηση";
        if (massAction === "send") return "Μαζική επανεπεξεργασία";
    }

    const renderMassActionBody = () => {
        if (massAction === "send") {
            return "Είσαστε σίγουροι ότι θέλετε να στείλετε τις επιλογές σας στο Primer ΑΙ; Η διαδικασία θα πραγματοποιηθεί στις συναλλαγές που είναι διαθέσιμη η λειτουργία της αποστολής τους.";
        }
        if (massAction === "decline") {
            return "Είσαστε σίγουροι ότι θέλετε να απορρίψετε τις επιλογές σας; Η διαδικασία θα πραγματοποιηθεί στις συναλλαγές που είναι διαθέσιμη η λειτουργία της απόρριψης.";
        }
        if (massAction === "register") {
            return "Είσαστε σίγουροι ότι θέλετε να καταχωρήσετε τις επιλογές σας; Η διαδικασία θα πραγματοποιηθεί στις συναλλαγές που είναι διαθέσιμη η λειτουργία της καταχώρησης.";
        }
        if (massAction === "reprocess") {
            return "Είσαστε σίγουροι ότι θέλετε να στείλετε προς επανεπεξεργασία τις επιλογές σας; Η διαδικασία θα πραγματοποιηθεί στις συναλλαγές που είναι διαθέσιμη η λειτουργία της επανεπεργασίας.";
        }
    }

    const toggleSort = (sortField) => {
        if (requestData.sortField === sortField) { // Toggle
            if (requestData.sortBy === "") {
                dispatch(setBankingAITransactionsReportRequestData({...requestData, sortBy: "DESC"}));
            } else if (requestData.sortBy === "DESC") {
                dispatch(setBankingAITransactionsReportRequestData({...requestData, sortBy: "ASC"}));
            } else if (requestData.sortBy === "ASC") {
                dispatch(setBankingAITransactionsReportRequestData({...requestData, sortBy: ""}));
            }
        } else { // Set
            dispatch(setBankingAITransactionsReportRequestData({...requestData, sortField, sortBy: "DESC"}));
        }
        setPageChanged(true);
    }

    const renderSortArrow = (sortField) => {
        if (!requestData.sortBy) return <React.Fragment></React.Fragment>
        if (requestData.sortField !== sortField) return <React.Fragment></React.Fragment>;

        if (requestData.sortBy === "ASC") return <FaArrowDown />
        else return <FaArrowUp />
    }

    const getAISelectedEntity = (transaction) => {
        let ent = "";
        let subAccountId = "";
        if (transaction && transaction?.ai_drafts && transaction?.ai_drafts[0]) {
            const obj0 = transaction.ai_drafts[0];
            if (obj0 && obj0.ai_document) {
                if (obj0.documentSection === "Client Payments") ent = obj0.ai_document.clientName;
                else if (obj0.documentSection === "Supplier Payments") ent = obj0.ai_document.supplierName;
                else if (obj0.documentSection === "Accounting Records") {
                    const entAccounts = obj0.ai_document.accounts.filter((el) => ["client", "supplier", "employee"].includes(el.subAccountType));
                    if (entAccounts.length === 1) ent = entAccounts[0].subAccount;
                    else ent = "";
                }
            }
            if (obj0?.documentSubCategory) subAccountId = obj0.documentSubCategory;
        } else if (transaction?.documentHooks?.length > 0) {
            const obj0 = transaction.documentHooks[0];
            if (obj0.correlatedEntityName) ent = obj0.correlatedEntityName;
            if (obj0?.subcategoryId) subAccountId = obj0.subcategoryId;
        }
        const title = "Εντοπισμένη οντότητα και υποκατηγορία από Primer AI";
        let style = {};
        let className = "";
        if (ent || subAccountId) {
            const subCat = bankingSubCategories.find((el) => el._id === subAccountId);
            if (subCat) {
                const cat = bankingCategories.find((el) => el._id === subCat.parentCategory);
                if (cat) {
                    if (ent && transaction?.ai_drafts?.length <= 1) ent = <><strong>{ent}</strong> : {subCat.title}</>
                    else ent = subCat.title;

                    className = "";
                    if (cat.title === "Πελάτες / Προμηθευτές") className = "badge-client-supplier";
                    else if (cat.title === "Πληρωμές Δημοσίου") className = "badge-public-sector";
                    else if (cat.title === "Μισθοδοσία") className = "badge-payroll";
                    else if (cat.title === "Ενδοεταιρικές διακινήσεις") className = "badge-intercompany";
                    else if (cat.title === "Δάνεια") className = "badge-loans";
                    else if (cat.title === "Τράπεζες") className = "badge-banks";
                    else if (cat.title === "Επιταγές") className = "badge-checks";
                    else if (cat.title === "Λοιπά") className = "badge-other";
                }
            }
            return <><br/><Badge style={style} className={`text-wrap text-break ${className}`} title={title}>{ent}</Badge></>
        }
        else return <React.Fragment></React.Fragment>
    }

    const askUserToReprocessAll = () => {
        axios.post(`${process.env.REACT_APP_API_URL2}/ai/check-for-3-continuous-changes`, {
            company: company.id,
        }).then((res) => {
            if (res.data.data >= 3) setShowReprocessAll(true);
        }).catch((err) => {
            console.log(err);
        })
    }

    const onReprocessAll = () => {
        setLoadingReprocessAll(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/ai/banking-reprocess-all`, {
            company: company.id,
        }).then((res) => {
            if (res.data.status === "200") {
                setShowReprocessAll(false);
                toast.success("Επιτυχής ενέργεια.");
                fetchReport(true);
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        }).finally(() => {
            setLoadingReprocessAll(false);
        })
    }

    const getAIScore = (transaction) => (transaction && transaction?.ai_drafts && transaction?.ai_drafts[0]) ? transaction.ai_drafts[0].score : "-";

    const hasSelectedBank = !isEmpty(requestData.accountId);
    const selectedBank = hasSelectedBank ? accountOptions.find((el) => requestData.accountId === el.value) : null;

    const renderLogDetails = (detailsStr) => {
        if (!detailsStr) return "-";
        if (!detailsStr.includes(" | ")) return <span>{detailsStr}</span>;
        if (!detailsStr.includes(" | ")) return <div style={{ textAlign: "center" }}>{detailsStr}</div>;

        const parts = detailsStr.split(" | ");
        const dataMap = {};
        parts.forEach(p => {
            const splitIdx = p.indexOf(":");
            if (splitIdx !== -1) {
                dataMap[p.substring(0, splitIdx).trim()] = p.substring(splitIdx + 1).trim();
            }
        });

        const newCount = parseInt(dataMap["Νέες"]) || 0;
        const updatedCount = parseInt(dataMap["Ενημερώθηκαν"]) || 0;

        return (
            <div style={{ lineHeight: "1.5" }}>
                <div style={{ fontWeight: "500", color: "#333", display: "flex", justifyContent: "center", flexWrap: "wrap" }}>
                    <span>
                        Σύνολο: {dataMap["Σύνολο Συναλλαγών"] || "0"}
                        <span style={{ margin: "0 6px", color: "#ccc" }}>•</span>
                        Νέες: <span style={{ color: newCount > 0 ? "#76aeb7" : "inherit", fontWeight: newCount > 0 ? "bold" : "normal" }}>{newCount}</span>
                        <span style={{ margin: "0 6px", color: "#ccc" }}>•</span>
                        Ενημερώθηκαν: <span style={{ color: updatedCount > 0 ? "#fd7e14" : "inherit", fontWeight: updatedCount > 0 ? "bold" : "normal" }}>{updatedCount}</span>
                    </span>
                    {dataMap["Ημ/νίες"] && (
                        <span style={{ marginLeft: "11px", marginTop: "2px", fontSize: "11px", color: "#76aeb7", backgroundColor: "#f1fdff", padding: "2px 6px", borderRadius: "4px" }}>
                            {dataMap["Ημ/νίες"]}
                        </span>
                    )}
                </div>

                <div style={{ color: "#6c757d", fontSize: "12px", justifyContent: "center", marginTop: "4px" }}>
                    {dataMap["Αρχείο"] && <span><i className="fa fa-file fa-sm"></i> {dataMap["Αρχείο"]}</span>}
                    {dataMap["Τράπεζα"] && <span style={{ marginLeft: "12px" }}><i className="fa-solid fa-building-columns fa-sm"></i> {dataMap["Τράπεζα"]} {dataMap["IBAN Λογαριασμού"] ? `(${dataMap["IBAN Λογαριασμού"]})` : ""}</span>}
                    {dataMap["Αποστολέας"] && <span style={{ marginLeft: "12px" }}><i className="fa-solid fa-envelope fa-sm"></i> {dataMap["Αποστολέας"]}</span>}
                </div>
            </div>
        );
    }

    const userDeclinesReprocessAll = () => {
        setShowReprocessAll(false);
        axios.post(`${process.env.REACT_APP_API_URL2}/ai/reset-3-continuous-changes`, {
            company: company.id,
        }).then((res) => {
            if (res.data.status === "200") toast.success("Η επιλογή σας αποθηκεύτηκε.");
        }).catch((err) => {
            console.log(err);
        })
    }

    return (
        <React.Fragment>
            <div className={"mb-3 product-form position-relative"} onClick={() => {
                if (bankingTransactionReportUniqueSelection) dispatch(setBankingAITransactionReportUniqueSelection(""));
            }}>
                {!hasSelectedBank && <div className="overlay_w">Παρακαλώ επιλέξτε έναν τραπεζικό λογαριασμό</div>}
                <div onKeyDown={(e) => {
                    if (e.key === "Enter") fetchReport(false);
                }}>
                    {companyDetails.automaticBankTransactionsEmailFetching ? (
                        <React.Fragment>
                            <Row className={"mb-2"}>
                                <Col md={4} className={"showWithOverlay"}>
                                    <OurDropdown name={"accountId"} label={"Τραπεζικός Λογαριασμός"} className={"mb-0"} options={accountOptions} required={true} defaultValue={selectedBank} onChange={(e) => handleOnChange(e, "dd", "accountId")} />
                                </Col>
                                <Col md={2}>
                                    {hasSelectedBank && selectedBank?.hooked === true ? (
                                        <ButtonGroup>
                                            <Button onClick={() => setShowFetchTransactions(true)} style={{padding: "10px", marginTop: "10px"}}>
                                                <FaDownload /> Άντληση Συναλλαγών
                                            </Button>
                                            <Button onClick={() => setShowMT940Modal(true)} style={{padding: "10px", marginTop: "10px"}}>
                                                <RiBankFill /> Εισαγωγή Συναλλαγών από MT940
                                            </Button>
                                        </ButtonGroup>
                                    ) : (
                                        <Button
                                            onClick={() => setShowMT940Modal(true)}
                                            style={{
                                                marginTop: "23px",
                                                width: "100%",
                                                minHeight: "54px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                padding: "10px",
                                            }}
                                        >
                                            <RiBankFill className="mr-1" style={{ fontSize: '1.5rem' }} /> Εισαγωγή Συναλλαγών από MT940
                                        </Button>
                                    )}
                                </Col>
                                <Col md={3}>
                                    <ButtonGroup style={{ marginTop: "23px", width: "100%" }}>
                                        <Button
                                            onClick={handleEmailSync}
                                            disabled={loadingEmailSync}
                                            style={{
                                                width: "100%",
                                                minHeight: "57px",
                                                borderTopRightRadius: 0,
                                                borderBottomRightRadius: 0,
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                padding: "10px",
                                            }}
                                        >
                                            <BsEnvelopeFill className="mr-1" style={{ fontSize: '1rem' }} /> Έλεγχος Συναλλαγών από Email
                                            {loadingEmailSync &&
                                                <Spinner className={"ml-2"} animation={"border"} size={"sm"} variant={"light"}/>
                                            }
                                        </Button>
                                        <Button
                                            onClick={handleOpenInfo}
                                            style={{
                                                marginTop: "0px",
                                                borderTopLeftRadius: 0,
                                                borderBottomLeftRadius: 0,
                                                borderLeft: "1px solid rgba(255, 255, 255, 0.15)",
                                                minWidth: "54px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                padding: 0
                                            }}
                                            title="Οδηγίες ελέγχου συναλλαγών από Email"
                                        >
                                            <BsInfoCircleFill style={{ fontSize: '1rem' }}/>
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                                <Col md={2}>
                                    <Button
                                        style={{
                                            marginTop: "23px",
                                            width: "100%",
                                            minHeight: "57px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            padding: "10px",
                                        }}
                                        onClick={() => { setShowLogsModal(true); fetchEmailLogs(1); }}
                                    >
                                        <FaHistory className={"mr-1"} style={{ fontSize: '1rem' }} /> Αρχείο Καταγραφής
                                    </Button>
                                </Col>
                            </Row>
                            <Row className={"mb-2"}>
                                <Col md={2}>
                                    <DateHelper dateFromAndToFunction={(from, to) => dispatch(setBankingAITransactionsReportRequestData({...requestData, date_from: from, date_to: to}))} />
                                </Col>
                                <Col md={2}>
                                    <DateBox name="date_from" selected={moment(requestData.date_from, "DD/MM/YYYY").isValid() ? moment(requestData.date_from, "DD/MM/YYYY").toDate() : ""} label={"Ημερομηνία από"} onChange={(e) => handleOnChange(e, "datebox", "date_from")} />
                                </Col>
                                <Col md={2}>
                                    <DateBox name="date_to" selected={moment(requestData.date_to, "DD/MM/YYYY").isValid() ? moment(requestData.date_to, "DD/MM/YYYY").toDate() : ""} label={"Ημερομηνία έως"} onChange={(e) => handleOnChange(e, "datebox", "date_to")} />
                                </Col>
                            </Row>
                            <Row className={"mb-2"}>
                                <Col md={4}>
                                    <Input name={"description"} type={"text"} label={"Περιγραφή Συναλλαγής"} value={requestData.description} autoComplete={"off"} onChange={(e) => handleOnChange(e, "input", "description")} />
                                </Col>
                                <Col md={2}>
                                    <Input name={"amount_from"} type={"number"} label={"Ποσό από"} value={requestData.amount_from} autoComplete={"off"} onChange={(e) => handleOnChange(e, "input", "amount_from")} />
                                </Col>
                                <Col md={2}>
                                    <Input name={"amount_to"} type={"number"} label={"Ποσό έως"} value={requestData.amount_to} autoComplete={"off"} onChange={(e) => handleOnChange(e, "input", "amount_to")} />
                                </Col>
                                <Col md={2}>
                                    <OurDropdown name={"status"} label={"Κατάσταση Συναλλαγής"} options={statusOptions} multiSelect={true} defaultValue={statusOptions.filter((el) => requestData.status.includes(el.value))} onChange={(e) => handleOnChange(e, "msdd", "status")} />
                                </Col>
                                <Col md={2}>
                                    <OurDropdown name={"sign"} label={"Πρόσημο Συναλλαγής"} options={signOptions} defaultValue={signOptions.filter((el) => el.value === requestData.sign)} onChange={(e) => handleOnChange(e, "dd", "sign")} />
                                </Col>
                            </Row>
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            <Row className={"mb-2"}>
                                <Col md={4} className={"showWithOverlay"}>
                                    <OurDropdown
                                        name={"accountId"}
                                        label={"Τραπεζικός Λογαριασμός"}
                                        className={"mb-0"}
                                        options={accountOptions}
                                        required={true}
                                        defaultValue={selectedBank}
                                        onChange={(e) => handleOnChange(e, "dd", "accountId")}
                                    />
                                </Col>
                                <Col md={2}>
                                    {hasSelectedBank && selectedBank?.hooked === true ? (
                                        <ButtonGroup>
                                            <Button onClick={() => setShowFetchTransactions(true)} style={{padding: "10px"}}>
                                                <FaDownload /> Άντληση Συναλλαγών
                                            </Button>
                                            <Button onClick={() => setShowMT940Modal(true)} style={{padding: "10px"}}>
                                                <RiBankFill /> Εισαγωγή Συναλλαγών από MT940
                                            </Button>
                                        </ButtonGroup>
                                    ) : (
                                        <Button onClick={() => setShowMT940Modal(true)} style={{marginTop: "14px"}}><RiBankFill /> Εισαγωγή Συναλλαγών από MT940</Button>
                                    )}
                                </Col>
                                <Col md={2}>
                                    <DateHelper
                                        dateFromAndToFunction={(from, to) => dispatch(setBankingAITransactionsReportRequestData({...requestData, date_from: from, date_to: to}))}
                                    />
                                </Col>
                                <Col md={2}>
                                    <DateBox
                                        name="date_from"
                                        selected={moment(requestData.date_from, "DD/MM/YYYY").isValid() ? moment(requestData.date_from, "DD/MM/YYYY").toDate() : ""}
                                        label={"Ημερομηνία από"}
                                        onChange={(e) => handleOnChange(e, "datebox", "date_from")}
                                    />
                                </Col>
                                <Col md={2}>
                                    <DateBox
                                        name="date_to"
                                        selected={moment(requestData.date_to, "DD/MM/YYYY").isValid() ? moment(requestData.date_to, "DD/MM/YYYY").toDate() : ""}
                                        label={"Ημερομηνία έως"}
                                        onChange={(e) => handleOnChange(e, "datebox", "date_to")}
                                    />
                                </Col>
                            </Row>
                            <Row className={"mb-2"}>
                                <Col md={4}>
                                    <Input
                                        name={"description"}
                                        type={"text"}
                                        label={"Περιγραφή Συναλλαγής"}
                                        value={requestData.description}
                                        autoComplete={"off"}
                                        onChange={(e) => handleOnChange(e, "input", "description")}
                                    />
                                </Col>
                                <Col md={2}>
                                    <Input
                                        name={"amount_from"}
                                        type={"number"}
                                        label={"Ποσό από"}
                                        value={requestData.amount_from}
                                        autoComplete={"off"}
                                        onChange={(e) => handleOnChange(e, "input", "amount_from")}
                                    />
                                </Col>
                                <Col md={2}>
                                    <Input
                                        name={"amount_to"}
                                        type={"number"}
                                        label={"Ποσό έως"}
                                        value={requestData.amount_to}
                                        autoComplete={"off"}
                                        onChange={(e) => handleOnChange(e, "input", "amount_to")}
                                    />
                                </Col>
                                <Col md={2}>
                                    <OurDropdown
                                        name={"status"}
                                        label={"Κατάσταση Συναλλαγής"}
                                        options={statusOptions}
                                        multiSelect={true}
                                        defaultValue={statusOptions.filter((el) => requestData.status.includes(el.value))}
                                        onChange={(e) => handleOnChange(e, "msdd", "status")}
                                    />
                                </Col>
                                <Col md={2}>
                                    <OurDropdown
                                        name={"sign"}
                                        label={"Πρόσημο Συναλλαγής"}
                                        options={signOptions}
                                        defaultValue={signOptions.filter((el) => el.value === requestData.sign)}
                                        onChange={(e) => handleOnChange(e, "dd", "sign")}
                                    />
                                </Col>
                            </Row>
                        </React.Fragment>
                    )}
                    <Row>
                        <Col md={4}>
                            <OurDropdown
                                name={"ai_status"}
                                label={"Κατάσταση ΑΙ"}
                                multiSelect={true}
                                options={aiStatusOptions}
                                defaultValue={aiStatusOptions.filter((el) => requestData.ai_status.includes(el.value))}
                                onChange={(e) => handleOnChange(e, "msdd", "ai_status")}
                            />
                        </Col>
                        <Col md={2}>
                            <Input
                                name={"ai_score_from"}
                                type={"number"}
                                label={"AI Score από"}
                                value={requestData.ai_score_from}
                                autoComplete={"off"}
                                onChange={(e) => handleOnChange(e, "input", "ai_score_from")}
                            />
                        </Col>
                        <Col md={2}>
                            <Input
                                name={"ai_score_to"}
                                type={"number"}
                                label={"AI Score έως"}
                                value={requestData.ai_score_to}
                                autoComplete={"off"}
                                onChange={(e) => handleOnChange(e, "input", "ai_score_to")}
                            />
                        </Col>
                        <Col md={4}>
                            <OurDropdown
                                name={"subcategories"}
                                label={"Υποκατηγορίες"}
                                multiSelect={true}
                                options={subCategoryOptions}
                                defaultValue={subCategoryOptions.filter((el) => requestData.subcategories.includes(el.value))}
                                onChange={(e) => handleOnChange(e, "msdd", "subcategories")}
                            />
                        </Col>
                    </Row>
                    <Row className={"d-flex justify-content-end"}>
                        <Col md={2} className={"d-flex justify-content-end"}>
                            <Button onClick={() => fetchReport(false)} disabled={loading} style={{height: "36px", lineHeight: "8px", width: "100%"}}>
                                Αναζήτηση {loading && <Spinner className={"ml-2"} animation={"border"} variant={"dark"}/>}
                            </Button>
                        </Col>
                    </Row>
                </div>
                {(responseData.totalPages > 0 && hasSelectedBank) && (
                    <React.Fragment>
                        <Row className={"mt-2"}>
                            <Col md={6}>
                                {selectedTransactions.length > 0 && (
                                    <div className={"mb-1"}>
                                        <i>Επιλεγμένες συναλλαγές {selectedTransactions.length} / {responseData?.transactionIds?.length || 0}</i>
                                        <ButtonGroup size={"sm"} className={"ml-2"} style={{height: "36px", lineHeight: "8px"}}>
                                            <Button onClick={() => clearSelections()}>Αποεπιλογή</Button>
                                            <Button onClick={() => setShowDeccorelateSelections(true)}>Αποσυσχέτιση</Button>
                                            <Button onClick={() => setShowDeccorelateAndDeleteSelections(true)} variant={"outline-danger"}>Αποσυσχέτιση & Διαγραφή</Button>
                                        </ButtonGroup>
                                    </div>
                                )}
                                {(!isEmpty(requestData.description) || !isEmpty(requestData.amount_from) || !isEmpty(requestData.amount_to)
                                    || requestData.status?.length > 0 || requestData.sign || requestData.ai_status?.length > 0
                                    || !isEmpty(requestData.ai_score_from) || !isEmpty(requestData.ai_score_to)
                                    || !(requestData.sortField === "valueDate" && ["DESC", ""].includes(requestData.sortBy))
                                ) && (
                                    <span><strong>(*) Προσοχή:</strong> Ενδέχεται λόγω των φίλτρων / ταξινομήσεων να μην προκύπτει σωστά το ποσό στη στήλη "Υπόλοιπο Λογιστικού Λογαριασμού"<br/></span>
                                )}
                            </Col>
                            <Col md={6} className={"d-flex justify-content-end"}>
                                {(responseData.differencePage > 0) && (
                                    <Badge bg={"primary"} className={"mr-2 mb-3"}
                                           style={{alignSelf: "center", padding: "2px", cursor: "pointer"}}
                                           title={"Προς σελίδα εκκίνησης διαφοράς Όψεως - Λογ. Λογαριασμού"}
                                           onClick={() => handlePageChange(responseData.differencePage, true)}
                                    >
                                        <TbLayersDifference size={26}/>
                                    </Badge>
                                )}
                                <Pagination
                                    currentPage={requestData.page}
                                    totalPages={responseData.totalPages}
                                    handlePageChange={(page) => handlePageChange(page)}
                                />
                            </Col>
                            <Col md={12}>
                                {selectedTransactions.length > 0 && renderMassActions()}
                            </Col>
                        </Row>
                        <Row className={"mt-2"}>
                            <Col md={12}>
                                <table className={"ai-module-table"}>
                                    <colgroup>
                                        <col span={1} style={{width: "3%"}}></col>
                                        <col span={1} style={{width: "32.5%"}}></col>
                                        <col span={1} style={{width: "7.5%"}}></col>
                                        <col span={1} style={{width: "7.5%"}}></col>
                                        <col span={1} style={{width: "7.5%"}}></col>
                                        <col span={1} style={{width: "7.5%"}}></col>
                                        <col span={1} style={{width: "7.5%"}}></col>
                                        <col span={1} style={{width: "15%"}}></col>
                                        <col span={1} style={{width: "5%"}}></col>
                                        {isAdmin && <col style={{ width: "5%" }} />}
                                        <col span={1} style={{width: "7.5%"}}></col>
                                    </colgroup>
                                    <thead>
                                    <tr>
                                        <th style={{zoom: "1.3"}}>
                                            <input
                                                style={{cursor: "pointer"}}
                                                type={"checkbox"}
                                                title={"Επιλογή όλων"}
                                                checked={selectedTransactions.length === responseData?.transactionIds?.length}
                                                onChange={() => toggleSelectAll()}
                                            />
                                        </th>
                                        <th>Περιγραφή Συναλλαγής</th>
                                        <th style={{cursor: "pointer"}} onClick={() => toggleSort("valueDate")}>Ημερομηνία {renderSortArrow("valueDate")}</th>
                                        <th style={{cursor: "pointer"}} onClick={() => toggleSort("transactionAmount")}>Ποσό πράξης {renderSortArrow("transactionAmount")}</th>
                                        <th>Υπόλοιπο Όψεως</th>
                                        <th title={"Υπόλοιπο Λογιστικού Λογαριασμού"}>Υπόλοιπο Λογ. Λογ.</th>
                                        <th>Κατάσταση Συσχέτισης</th>
                                        <th>Κατάσταση ΑΙ</th>
                                        <th style={{cursor: "pointer"}} onClick={() => toggleSort("ai_score")}>AI Score {renderSortArrow("ai_score")}</th>
                                        {isAdmin && <th>Credits</th>}
                                        <th>Ενέργειες</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {responseData.data.map((transaction, idx) => (
                                        <tr
                                            key={`aba-${idx}`}
                                            style={{
                                                backgroundColor: bankingTransactionReportUniqueSelection === transaction._id ? "lightblue" : "",
                                                cursor: "pointer",
                                            }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                const selection = window.getSelection();
                                                if (selection && selection.toString().length > 0) return;
                                                dispatch(setBankingAITransactionReportUniqueSelection(transaction._id));
                                                if (+transaction.transactionAmount > 0) {
                                                    handleDocumentAction(transaction, "Client Payments");
                                                } else {
                                                    handleDocumentAction(transaction, "Supplier Payments")
                                                }
                                            }}
                                            ref={transaction._id === responseData.differenceId ? diffRef : null}
                                        >
                                            <td
                                                style={{zoom: "1.3"}}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    toggleSelection(transaction._id);
                                                }}
                                            >
                                                <input
                                                    type={"checkbox"}
                                                    title={"Επιλογή"}
                                                    checked={selectedTransactions.includes(transaction._id)}
                                                />
                                            </td>
                                            <td>{transaction["erp_description"]}{getAISelectedEntity(transaction)}</td>
                                            <td>{moment(transaction["valueDate"]).format("DD/MM/YYYY")}</td>
                                            <td>{getGreekCurrencyFormat(transaction.transactionAmount)}</td>
                                            <td>{getGreekCurrencyFormat(transaction["runningBalance"] || 0)}</td>
                                            <td style={{backgroundColor: isEmpty(transaction.difference) ? "lightgray" : transaction.difference === true ? "#f79292" : "lightgreen"}}>
                                                {transaction["accountingBalance"] === "-" ? ">>" : getGreekCurrencyFormat(transaction["accountingBalance"] || 0)}
                                            </td>
                                            <td>{getDocumentHooksStatus(transaction["documentHooksStatus"])}</td>
                                            <td className={`status-td ${formatAIBankingStatusColor(transaction)}`} style={{fontWeight: "600", letterSpacing: "0.3px", borderRadius: "6px"}}>
                                                {formatAIBankingStatus(transaction)}
                                            </td>
                                            <td>
                                                {getAIScore(transaction)}
                                            </td>
                                            {isAdmin && <td>{transaction.ai_credits}</td>}
                                            <td style={{padding: "2px"}}>
                                                {renderActionButtons(transaction)}
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </Col>
                        </Row>
                        <Row className={"mt-2"}>
                            <Col md={7}>
                                <BootstrapDropdown className="mb-3 mt-3">
                                    <BootstrapDropdown.Toggle variant="primary" id="dropdown-basic" disabled={loadingExport}>
                                        Αποθήκευση αποτελεσμάτων {loadingExport && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} size="sm" />}
                                    </BootstrapDropdown.Toggle>
                                    <BootstrapDropdown.Menu>
                                        <BootstrapDropdown.Item onClick={() => handlePDFExport()}>
                                            Αποθήκευση ως PDF
                                        </BootstrapDropdown.Item>
                                        <BootstrapDropdown.Item onClick={() => handleExcelExport()}>
                                            Αποθήκευση ως XLSX
                                        </BootstrapDropdown.Item>
                                    </BootstrapDropdown.Menu>
                                </BootstrapDropdown>
                            </Col>
                            <Col md={5}>
                                {responseData.totals && (
                                    <table className={"simpleClassicTable"} style={{fontSize: "16px", fontWeight: "600"}}>
                                        <thead>
                                        <tr>
                                            <th colSpan={2}>Σύνολα</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr>
                                            <td>Πλήθος Συναλλαγών</td>
                                            <td>
                                                {responseData.totals.totalCount}
                                                <Badge bg={"success"} style={{fontSize: "16px"}} className={"ml-2 p-1"} title={"Συσχετισμένες"}>{responseData.totals.countComplete}</Badge>
                                                <Badge bg={"warning"} style={{fontSize: "16px"}} className={"ml-2 p-1"} title={"Μερικώς Συσχετισμένες"}>{responseData.totals.countPending}</Badge>
                                                <Badge bg={"danger"} style={{fontSize: "16px"}} className={"ml-2 p-1"} title={"Ασυσχέτιστες"}>{responseData.totals.countEmpty}</Badge>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Σύνολο Χρεώσεων</td>
                                            <td>{getGreekCurrencyFormat(responseData.totals.totalDebit)}</td>
                                        </tr>
                                        <tr>
                                            <td>Σύνολο Πιστώσεων</td>
                                            <td>{getGreekCurrencyFormat(responseData.totals.totalCredit)}</td>
                                        </tr>
                                        <tr>
                                            <td>Λογιστικό Αποτέλεσμα</td>
                                            <td>{getGreekCurrencyFormat(responseData.totals.totalSum)}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                )}
                            </Col>
                        </Row>
                    </React.Fragment>
                )}
            </div>

            <DeleteDecorrelateModal
                show={showDeccorelateAndDeleteSelections}
                setShow={setShowDeccorelateAndDeleteSelections}
                selectedTransactions={selectedTransactions}
                successCallback={() => fetchReport(true)}
            />

            <BankTransactionsModal
                show={showFetchTransactions}
                setShow={setShowFetchTransactions}
                selectedBank={selectedBank}
            />

            <HookTransactionModal
                callback={() => {
                    fetchReport(true);
                    askUserToReprocessAll();
                }}
                onAIRegister={(transaction, forceDrafts) => {
                    handleAI(transaction, "register", forceDrafts);
                }}
                onAIReprocess={(transaction) => {
                    handleAI(transaction, "reprocess");
                }}
                onAIDecline={(transaction) => {
                    handleAI(transaction, "decline");
                }}
                upgraded={true}
            />
            <UploadMT940Modal
                show={showMT940Modal}
                setShow={setShowMT940Modal}
                selectedBank={selectedBank}
            />

            <Modal show={showDeccorelateSelections} onHide={() => setShowDeccorelateSelections(false)} backdrop={"static"}>
                <Modal.Header closeButton>
                    <Modal.Title>Αποσυσχέτιση επιλεγμένων</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Είσαστε σίγουροι ότι θέλετε να αποσυσχετίσετε τις επιλεγμένες συναλλαγές από τις εγγραφές τους;
                </Modal.Body>
                <Modal.Footer>
                    <Button disabled={loadingDecorrelate} variant="primary" onClick={() => handleDeccorelateSelections()}>
                        Ναι, αποσυσχέτιση {loadingDecorrelate && <Spinner className={"ml-2"} animation={"border"} variant={"dark"}/>}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showMassModal} onHide={() => setShowMassModal(false)} backdrop={"static"}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {renderMassActionTitle()}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {renderMassActionBody()}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShowMassModal(false)} disabled={massLoading}>
                        Όχι, κλείσιμο
                    </Button>
                    <Button variant="primary" onClick={() => onMassAction()} disabled={massLoading}>
                        Ναι, εκτέλεση ενέργειας {massLoading && <Spinner className={"ml-2"} animation={"border"} variant={"dark"}/>}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showReprocessAll} onHide={() => setShowReprocessAll(false)} backdrop={"static"}>
                <Modal.Header closeButton>
                    <Modal.Title>Απαιτείται προσοχή</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Παρατηρήσαμε ότι έχετε αλλάξει αντισυμβαλλόμενη οντότητα πάνω από 3 φορές. Θα θέλατε να γίνει επανεπεξεργασία όλων των συναλλαγών;
                    <BetterCheckBox
                        name={"doNotReshow3"}
                        text={"Να μην ξαναενημερωθώ για τις επόμενες συναλλαγές"}
                        className={"mt-3 mb-1"}
                        checked={doNotReshow3}
                        onChange={(e) => setDoNotReshow3(e.target.checked)}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => userDeclinesReprocessAll()}>
                        Όχι, κλείσιμο
                    </Button>
                    {!doNotReshow3 && (
                        <Button variant="primary" onClick={() => onReprocessAll()} disabled={loadingReprocessAll}>
                            Ναι, επανεπεξεργασία όλων {loadingReprocessAll && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} size="sm" />}
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>

            <Modal show={showLogsModal} onHide={() => setShowLogsModal(false)} dialogClassName={"modal65PercentWidth"} backdrop={"static"}>
                <Modal.Header closeButton>
                    <Modal.Title>Ιστορικό Αυτόματου Συγχρονισμού Μέσω Email</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loadingLogs ? (
                        <div style={{textAlign: "center", padding: "30px"}}>
                            <Spinner animation="border" variant="primary" />
                        </div>
                    ) : (
                        <React.Fragment>
                            {logsTotalPages > 1 && (
                                <div className={"d-flex justify-content-end"}>
                                    <Pagination
                                        currentPage={logsPage}
                                        totalPages={logsTotalPages}
                                        handlePageChange={(page) => fetchEmailLogs(page)}
                                    />
                                </div>
                            )}
                            <table className={"simpleClassicTable"}>
                                <colgroup>
                                    <col span={1} style={{width: "15%"}}></col>
                                    <col span={1} style={{width: "20%"}}></col>
                                    <col span={1} style={{width: "65%"}}></col>
                                </colgroup>
                                <thead>
                                <tr>
                                    <th>Ημερομηνία & Ώρα</th>
                                    <th>Εκτέλεση Από</th>
                                    <th>Λεπτομέρειες</th>
                                </tr>
                                </thead>
                                <tbody>
                                {logsData.length > 0 ? (
                                    logsData.map((log, idx) => (
                                        <tr key={`log-${idx}`}>
                                            <td>{moment(log.created_at).format("DD/MM/YYYY HH:mm:ss")}</td>
                                            <td>
                                                {log.user === "System Automations (CRON)" ? (
                                                    <Badge bg="secondary">System Automations (CRON)</Badge>
                                                ) : (
                                                    <Badge bg="primary">{log.user}</Badge>
                                                )}
                                            </td>
                                            <td>
                                                {renderLogDetails(log.fieldsChanged)}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={3} style={{textAlign: "center", padding: "5px", backgroundColor: "#ecf0f5"}}>
                                            Δεν βρέθηκαν καταγραφές.
                                        </td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                        </React.Fragment>
                    )}
                </Modal.Body>
            </Modal>

            <Modal show={showInfo} onHide={handleCloseInfo} dialogClassName={"modal45PercentWidth"}>
                <Modal.Header closeButton>
                    <Modal.Title>Οδηγίες Ελέγχου Συναλλαγών από Email</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="mb-3">
                        Για την επιτυχή λήψη και επεξεργασία των τραπεζικών σας δεδομένων από την εφαρμογή, παρακαλούμε όπως ακολουθήσετε τα παρακάτω βήματα στο περιβάλλον της τράπεζάς σας:
                    </p>

                    <ul style={{ listStyle: "none", paddingLeft: "5px" }}>
                        <li className="mb-3 d-flex align-items-start">
                            <span className="text-primary mr-2" style={{ fontSize: "1.1rem", lineHeight: "1" }}>•</span>
                            <div>
                                <strong>Σύνδεση στην υπηρεσία:</strong> Πραγματοποιήστε είσοδο (Login) στην επίσημη πλατφόρμα <strong>Web Banking</strong> της συμβεβλημένης τράπεζάς σας.
                            </div>
                        </li>
                        <li className="mb-3 d-flex align-items-start">
                            <span className="text-primary mr-2" style={{ fontSize: "1.1rem", lineHeight: "1" }}>•</span>
                            <div>
                                <strong>Εντοπισμός της υπηρεσίας:</strong> Πλοηγηθείτε στο κεντρικό μενού και επιλέξτε την ενότητα <strong>«Αποστολή κινήσεων με Email»</strong> (ή την αντίστοιχη ονομασία που χρησιμοποιεί το ίδρυμά σας για την εξαγωγή κινήσεων).
                            </div>
                        </li>
                        <li className="mb-3 d-flex align-items-start">
                            <span className="text-primary mr-2" style={{ fontSize: "1.1rem", lineHeight: "1" }}>•</span>
                            <div>
                                <strong>Ορισμός τύπου αρχείου:</strong> Στο πεδίο μορφοποίησης, επιλέξτε ως τύπο αρχείου εξαγωγής το πρότυπο <strong>MT940</strong>.
                            </div>
                        </li>
                        <li className="mb-3 d-flex align-items-start">
                            <span className="text-primary mr-2" style={{ fontSize: "1.1rem", lineHeight: "1" }}>•</span>
                            <div>
                                <strong>Καταχώριση email λήψης:</strong> Ορίστε ως διεύθυνση ηλεκτρονικού ταχυδρομείου (Email) στην οποία θα αποστέλλονται οι κινήσεις του λογαριασμού σας το Email: <strong>bankstatements@primer.gr</strong>.
                            </div>
                        </li>
                        <li className="mb-3 d-flex align-items-start">
                            <span className="text-primary mr-2" style={{ fontSize: "1.1rem", lineHeight: "1" }}>•</span>
                            <div>
                                <strong>Ασφάλεια αρχείου:</strong> Ορίστε ως κωδικό πρόσβασης (Password) για το κλείδωμα και την αποσυμπίεση του αρχείου μορφής .zip αποκλειστικά τον κωδικό: <strong>P800566476</strong>.
                            </div>
                        </li>
                        <li className="mb-3 d-flex align-items-start">
                            <span className="text-primary mr-2" style={{ fontSize: "1.1rem", lineHeight: "1" }}>•</span>
                            <div>
                                <strong>Προγραμματισμός αποστολής:</strong> Καθορίστε την επιθυμητή <strong>συχνότητα αποστολής</strong> του email (π.χ. ημερήσια ή όποτε σημειώνεται κίνηση του λογαριασμού), ανάλογα με τις ανάγκες της επιχείρησής σας.
                            </div>
                        </li>
                    </ul>

                    <div className="alert alert-danger mt-4 mb-0" style={{ fontSize: "0.9rem", lineHeight: "1.4" }}>
                        <strong>Προσοχή:</strong> Εάν το email ή ο κωδικός πρόσβασης <strong>δεν οριστούν σωστά</strong>, η αυτόματη ανάγνωση θα αποτύχει και <strong>οι συναλλαγές σας δεν θα εισαχθούν</strong> στο σύστημα.
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleCloseInfo}>
                        ΟΚ
                    </Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    )
}

export default AccountingAIBankingTransactions;